import { User } from "../../../../authentication/domain";

export class GoogleCalendarIntegrationSettings {
  constructor(
    public readonly enabled: boolean,
    public readonly connectedUser: User | null
  ) {}
}
